import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './../Personnel/Employees.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {CreateTable, CreateTableForEmployeeSelect} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {useTable, useSortBy} from 'react-table';
// icon
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

function EmployeeBankAccount({user, isHideSideMenu}) {
    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    var header = [
        "Id",
        "Employee Id",
        "Employee Name",
        "Bank Account",
        "Bank Name",
        "",
    ]
    var accessor = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "bankAccount",
        "bankName",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [employeeBankAccount, setEmployeeBankAccount] = useState([]);
    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [dataToFetch, setDataToFetch] = useState("");
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by employee name");
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [bankAccount, setBankAccount] = useState("");
    const [bankName, setBankName] = useState("");
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [editEmployeePersonalInformationId, setEditEmployeePersonalInformationId] = useState("");
    const [editEmployeePersonalInformationFullName, setEditEmployeePersonalInformationFullName] = useState("");
    const [editBankAccount, setEditBankAccount] = useState("");
    const [editBankName, setEditBankName] = useState("");
    //old
    const [oldEditBankAccount, setOldEditBankAccount] = useState("");
    const [oldEditBankName, setOldEditBankName] = useState("");

    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/EmployeeBankAccount";

    const fetchData = useCallback(async (dataToFetch) => {
        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl + dataToFetch}/username/${user.username}` , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setEmployeeBankAccount(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl, user]);

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by employee name")
                setDataToFetch("");
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                setDataToFetch("")
                break;
            case 2:
                setSearchPlaceholder("Search by bank id")
                setDataToFetch("");
                break;
            case 3:
                setSearchPlaceholder("Search by bank name")
                setDataToFetch("/account");
                break;
            default:
                setSearchPlaceholder("Search by employee name")
                setDataToFetch("");
                break;
        }
        fetchData(dataToFetch);
        
    }, [filterDataIndex, dataToFetch, fetchData]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(value)
                );
                break;
            case 2:
                res = filterData.filter((f) =>
                f.bankAccount.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 3:
                res = filterData.filter((f) =>
                f.bankName.toLowerCase().includes(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployeeBankAccount(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!employeePersonalInformationId || !bankAccount || !bankName) {
            alert("Required to fill up all data");
            return; // Exit early if fields are empty
        }

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            bankAccount: bankAccount,
            bankName: bankName
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Employee Bank Account", 
                actionTaken: "insert", 
                field: "Add", 
                newValue: `${bankName}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setBankAccount("");
            setBankName("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: editEmployeePersonalInformationId,
            bankAccount: editBankAccount,
            bankName: editBankName
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            let auditInfo = [];

            if(data.bankAccount !== oldEditBankAccount){
                auditInfo.push({
                    setupArea: "Employee Bank Account",
                    actionTaken: "update",
                    field: "Bank Account",
                    newValue: `${data.bankAccount}`,
                    oldValue: `${oldEditBankAccount}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.bankName !== oldEditBankName){
                auditInfo.push({
                    setupArea: "Employee Bank Account",
                    actionTaken: "update",
                    field: "Bank Name",
                    newValue: `${data.bankName}`,
                    oldValue: `${oldEditBankName}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false);
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(""); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditEmployeePersonalInformationId("");
            setEditBankAccount("");
            setEditBankName("");
            setEditById("");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setEditEmployeePersonalInformationId(data.employeePersonalInformationId);
        setEditEmployeePersonalInformationFullName(data.employeePersonalInformationFullName);
        setEditBankAccount(data.bankAccount);
        setEditBankName(data.bankName);
        setOldEditBankAccount(data.bankAccount);
        setOldEditBankName(data.bankName);
        setShowEditForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);

    const generateDownloadTemplate = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeeBankAccount');

        const header = [
            'EmployeeId',
            'EmployeeName',
            'BankAccount',
            'BankName',
        ];
        const headerRow = worksheet1.addRow(header);
        worksheet1.columns = [
            { key: 'employeeId', width: 30 },
            { key: 'employeeName', width: 30 },
            { key: 'bankAccount', width: 30 },
            { key: 'bankName', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const information = [
            {
                employeeId: "<EMP1234>",
                employeeName: "<DELA CRUZ, JUAN>",
                bankAccount: "<BANK#123>",
                bankName: "<BANKNAME>",
            },
        ];

        information.forEach(info => {
            worksheet1.addRow(info);
        });
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Employee_Bank_Account_Template.xlsx');
    }, []);

    const [showUploadForm, setShowUploadForm] = useState(false);
    const [uploadData, setUploadData] = useState([])
    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }

    const fetchDataForEmployee = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/single-data";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);

    const uploadEmployeeData = async (file) => {
        setLoadingRequest(true);
        const dataEmployee = await fetchDataForEmployee();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value.toString();
        }
        function validateData(data) {
            let newData = [];
        
            data.forEach((item, index) => {
                const missing = [];
                
                if (!item.employeeId) missing.push('Employee Id');
        
                // ✅ Construct error message properly
                let errorMessage = "";

                const existingEmployee = dataEmployee.find(employee => employee.employeeId === item.employeeId?.toString());
                if (!existingEmployee) {
                    errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
                }
        
                if (missing.length > 0) {
                    errorMessage += ` Missing fields - ${missing.join(', ')}`;
                }
        
                newData.push({ ...item, errors: errorMessage });
            });
            
            newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

            return newData;
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            let bulkData = [];
    
            informations.forEach(info => {
                let foundEmployee = null;

                foundEmployee = dataEmployee.find(data => data.employeeId.toLowerCase() === sanitizeValue(info.EmployeeId).toString().toLowerCase());

                // i will use the locations, employments etc. here below
                bulkData.push({
                    employeeId: sanitizeValue(info.EmployeeId),
                    fullName: sanitizeValue(info.EmployeeName),
                    employeePersonalInformationId: foundEmployee ?
                                sanitizeValue(foundEmployee.id)
                                :
                                0,
                    bankName: info.BankName ? 
                                sanitizeValue(info.BankName)
                                :
                                0,
                    bankAccount: info.BankAccount ? 
                                sanitizeValue(info.BankAccount)
                                :
                                0,
                });
            });

            // console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
    
            // Validate the bulk data
            const validatedData = validateData(bulkData);
            const sortedData = validatedData.sort((a, b) => {
                const hasErrorA = a.errors && a.errors.length > 0;
                const hasErrorB = b.errors && b.errors.length > 0;
            
                return hasErrorB - hasErrorA; // Move items with errors to the top
            });
            setUploadData(sortedData)

            /* if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(validation.message.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                )));
                return;
            }

            const apiUrl = `${domain}/api/EmployeeSalary/bulk`;
        
            try {
                const response = await axios.post(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                
                console.log('Upload successful:', response.data);
                await SetAuditTrail({
                    setupArea: "Employee Salary", 
                    actionTaken: "upload", 
                    field: "Upload", 
                    newValue: `-`, 
                    oldValue: "-", 
                    dateSaved: new Date(), 
                    savedById: user.id
                });
                await createHistoryBulk(bulkData)
                await fetchData(); // Assuming fetchData() fetches the updated data for the table

                setShowRequestMessage(true);
                setIsSuccess(true);
            } catch (error) {
                setShowRequestMessage(true);
                setIsSuccess(false);
                console.error('Error:', error);
                const errorMessage = JSON.parse(error.response.request.responseText).message;
                setRequestMessage(errorMessage);
            }
            
            setLoadingRequest(false); */
        };
    
        setLoadingRequest(false)
        reader.readAsArrayBuffer(file);
    };
    
    function handleFileUpload(files) {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }
    const handleFinalFileUpload = async (bulkData) => {
        setLoadingRequest(true);
            
        const apiUrl = `${domain}/api/EmployeeBankAccount/bulk`;
    
        try {
            const response = await axios.post(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            console.log('Upload successful:', response.data);
            await SetAuditTrail({
                setupArea: "Employee Bank Account", 
                actionTaken: "upload", 
                field: "Upload", 
                newValue: `-`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(dataToFetch); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = [
            'Id',
            'Employee Id',
            'Employee Name',
            'Bank Account',
            'Bank Name',
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'bankAccount', width: 30 },
            { key: 'bankName', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const sortedData = [...employeeBankAccount].sort((a, b) => {
            // Sort by Name first
            if (a.employeePersonalInformationFullName < b.employeePersonalInformationFullName) return -1;
            if (a.employeePersonalInformationFullName > b.employeePersonalInformationFullName) return 1;
        
            // If Name is the same, sort by Date
            return new Date(a.date) - new Date(b.date);
        });
    
        sortedData.forEach((item) => {
            worksheet.addRow([
                item.id,
                item.employeePersonalInformationEmployeeId,
                item.employeePersonalInformationFullName,
                item.bankAccount,
                item.bankName,
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'EmployeeBankAccounts.xlsx');
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo TimeInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Salary Module >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Employee Bank Account"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Employee Bank Account</h3>
                                <div style={{width:"30%",textAlign:"right"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit generateDownloadTemplate={generateDownloadTemplate} openUploadFormHandleClick={openUploadFormHandleClick}
                                            />}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="employeesTab-body transaction-body">
                            {Filter(setFilterDataIndex)}
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                        "mainte-search row", 
                                                                        "mainte-search-icon", 
                                                                        "mainte-search-input", 
                                                                        (e) => handleFilter(e.target.value), 
                                                                        searchPlaceholder, 
                                                                        SearchIcon)}
                                </div>
                                <div className="body-top-btn row" style={{justifyContent: "end"}}>
                                        {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className='timeBtns'>
                                <div className="timeBtn extract row">
                                    {CreateButton("", "icon row", exportToExcel, "EXTRACT", FileCopyIcon)}
                                </div>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={employeeBankAccount}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    bankAccount={bankAccount}
                    bankName={bankName}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setBankAccount={setBankAccount}
                    setBankName={setBankName}
                    setShowEmployeeForm={setShowEmployeeForm}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editEmployeePersonalInformationId={editEmployeePersonalInformationId}
                    editEmployeePersonalInformationFullName={editEmployeePersonalInformationFullName}
                    editBankAccount={editBankAccount}
                    editBankName={editBankName}
                    setEditEmployeePersonalInformationId={setEditEmployeePersonalInformationId}
                    setEditBankAccount={setEditBankAccount}
                    setEditBankName={setEditBankName}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
            >
            </EmployeeSelectForm>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    data_temp={uploadData}
                    setData_temp={setUploadData}
                    handleFileUpload={handleFileUpload}
                    handleFinalFileUpload={handleFinalFileUpload}
            >
            </UploadForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "10000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function SettingInit({
    generateDownloadTemplate,
    openUploadFormHandleClick,
}){
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Data
            </div>
        </div>
    )
}
function AddForm({isOpen, 
    onClose,
    employeePersonalInformationId,
    employeePersonalInformationFullName,
    bankAccount,
    bankName,
    setEmployeePersonalInformationId,
    setBankAccount,
    setBankName,
    setShowEmployeeForm,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!employeePersonalInformationId || !bankAccount || !bankName) {
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setBankAccount("");
        setBankName("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Bank Account</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Bank Account</div>
                                <div className="info-item-input">
                                    <input
                                    id="bankAccount"
                                    placeholder="Bank Account"
                                    value={bankAccount}
                                    onChange={(e) => setBankAccount(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !bankAccount && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Bank Name</div>
                                <div className="info-item-input">
                                    <input
                                    id="bankName"
                                    placeholder="Bank Name"
                                    value={bankName}
                                    onChange={(e) => setBankName(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !bankName && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    editEmployeePersonalInformationId,
    editEmployeePersonalInformationFullName,
    editBankAccount,
    editBankName,
    setEditBankAccount,
    setEditBankName, 
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if (!editEmployeePersonalInformationId || !editBankAccount || !editBankName) {
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Bank Account</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee Id</div>
                            <div className="info-item-input">
                                <input
                                    readOnly
                                    className='employeeInput-select'
                                    placeholder="Primary Approver"
                                    value={editEmployeePersonalInformationId + " - " + editEmployeePersonalInformationFullName}
                                    style={{cursor:"not-allowed"}}
                                />
                            </div>
                            <span style={{
                                        visibility: !editEmployeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Bank Account</div>
                                <div className="info-item-input">
                                    <input
                                    id="editBankAccount"
                                    placeholder="Bank Account"
                                    value={editBankAccount}
                                    onChange={(e) => setEditBankAccount(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !editBankAccount && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Bank Name</div>
                                <div className="info-item-input">
                                    <input
                                    id="editBankName"
                                    placeholder="Bank Name"
                                    value={editBankName}
                                    onChange={(e) => setEditBankName(e.target.value)}
                                    />
                                </div>
                                <span style={{
                                        visibility: !editBankName && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "Id":
                setFilterDataIndex(1);
                break;
            case "BankId":
                setFilterDataIndex(2);
                break;
            case "BankAccount":
                setFilterDataIndex(3);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="Id">Id</option>
                <option value="BankId">Bank Id</option>
                <option value="BankAccount">Bank Account</option>
            </select>
        </div>
    );
};
function UploadForm({isOpen, 
    onClose,
    data_temp,
    setData_temp,
    handleFileUpload,
    handleFinalFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
        setData_temp([]);
    };

    const [files, setFiles] = useState([]);
    const [currentFiles, setCurrentFiles] = useState([]);
    const [hasNoError, setHasNoError] = useState(false);

    useEffect(() => {
        if(data_temp.length > 0){
            const _errorData = data_temp.filter(i => i.errors.length > 0)

            if(_errorData.length <= 0){
                setHasNoError(true)
            } else {
                setHasNoError(false)
            }
        }
    }, [data_temp])

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
        setData_temp([]);
    };

    useEffect(() => {
        if(currentFiles !== files){
            setCurrentFiles(files)
            handleFileUpload(files);
        }
    }, [files, handleFileUpload, currentFiles])

    const submit = (e) =>{
        handleFinalFileUpload(data_temp);
        handleClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    var header = [
        "Employee Id",
        "Employee Name",
        "Bank Account",
        "Bank Name",
        "Error",
    ]
    var accessor = [
        "employeeId",
        "fullName",
        "bankAccount",
        "bankName",
        "errors",
    ]

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Data"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>

                    <div className="popUp-body user-template-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>

                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <>
                            {hasNoError ?
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white"}}>
                                    Data is valid.
                                </div>
                            </>
                            :
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white"}}>
                                    Cannot upload with error.
                                </div>
                            </>
                            }
                            <div className='employeesTab-tab upload-preview-tab' style={{marginTop: "10px"}}>
                                <div id="container1 table-uploads" className="employeesTab-table container">
                                    <CreateTableForUpload
                                        dataList={data_temp}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                            <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                                {hasNoError && <button id="add-family" 
                                    className="save row"
                                    onClick={(e)=>submit(e)}
                                    style={{marginRight:"5px"}}>
                                        UPLOAD
                                </button>}
                                <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>handleClose()}>
                                        CANCEL
                                </button>
                            </div>
                        </>
                        )
                    }
                    
                    
                </div>
            )}
            </div>
        </>
    );
}
function CreateTableForUpload({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [],
    currentPage, setCurrentPage,
}) {
    const itemsPerPage = 5;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                className={row.original.error ? "error" : ""}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForUpload header={cell.render("Cell").props.column.Header}
                                        _cell={cell}
                                        />
                                    ))}
                                </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForUpload({header, 
    _cell, 
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Photo") {
        if(data.photo){
            const imageSrc = 'data:image/jpeg;base64,' + data.photo;

            return(
                <td>
                    <img className="avatarImg" src={imageSrc} alt=""/>
                </td>
            )
        }
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if(header === "Date Created"
    ){
        if(!value){
            return (
                <td>
                </td>
            );
        }

        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if(header === "Error"
    ){
        return (
            <td>
                {value && (
                    <p style={{ color: "red", margin: 0 }}>
                        {value}
                    </p>
                )}
            </td>
        );
    }

    if( header === "Vacation Leave"
    || header === "Sick Leave"
    || header === "Service Incentive Leave"
    || header === "Solo Parent Leave"
    || header === "Vacation Leave Remaining"
    || header === "Sick Leave Remaining"
    || header === "Service Incentive Leave Remaining"
    || header === "Solo Parent Leave Remaining"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
export default EmployeeBankAccount
